<template>
    <v-container fluid>
        <!-- Banner-Locations -->
        <v-row dense>
            <v-col cols="3" class="d-flex align-center">
                <label class="tgk-paragraph-text">{{ $t('banner_location') }}</label>
            </v-col>
            <v-col cols="9">
                <banner-location-select v-model="searchParams.location_ident" />
            </v-col>
        </v-row>

        <!-- Banner-Locations -->
        <v-row dense>
            <v-col cols="3" class="d-flex align-center">
                <label class="tgk-paragraph-text">{{ $t('commercial') }}</label>
            </v-col>
            <v-col cols="9">
                <BannerCommercialSelect v-model="searchParams.commercial" />
            </v-col>
        </v-row>

        <!-- Erstellt -->
        <v-row dense>
            <v-col cols="3" class="d-flex align-center">
                <label class="tgk-paragraph-text">{{ $t('erstellt') }}</label>
            </v-col>
            <v-col cols="9" class="d-flex">
                <DateTextfield v-model="searchParams.created_from" input-class="mr-1" :placeholder="$t('von')" />
                <DateTextfield v-model="searchParams.created_to" :placeholder="$t('bis')" />
            </v-col>
        </v-row>

        <!-- bearbeitet -->
        <v-row dense>
            <v-col cols="3" class="d-flex align-center">
                <label class="tgk-paragraph-text">{{ $t('bearbeitet') }}</label>
            </v-col>
            <v-col cols="9" class="d-flex">
                <DateTextfield v-model="searchParams.modified_from" input-class="mr-1" :placeholder="$t('von')" />
                <DateTextfield v-model="searchParams.modified_to" :placeholder="$t('bis')" />
            </v-col>
        </v-row>

        <!-- publiziert -->
        <v-row dense>
            <v-col cols="3" class="d-flex align-center">
                <label class="tgk-paragraph-text">{{ $t('publiziert') }}</label>
            </v-col>
            <v-col cols="9" class="d-flex">
                <DateTextfield v-model="searchParams.published_from" input-class="mr-1" :placeholder="$t('von')" />
                <DateTextfield v-model="searchParams.published_to" :placeholder="$t('bis')" />
            </v-col>
        </v-row>

        <v-row dense>
            <v-col class="d-flex justify-end">
                <PlainBtn @click="onResetBtn">{{ $t('reset_search') }}</PlainBtn>
                <ActionBtn class="ml-1" @click="onSearchBtn">
                    <KpIcon icon-cls="searchmagnifier" color="white" left />
                    {{ $t('search') }}
                </ActionBtn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import BannerLocationSelect from '@/components/banner/banner-location-select.vue';
import BannerCommercialSelect from '@/components/banner/banner-commercial-select.vue';

/**
 * Enhanced Search Component for banner search
 *
 * Emits:
 * - search(params): when the user click on "search"
 * - reset: when the user clicks on "reset"
 *
 * The initial search params can be set via initial-params property.
 */
export default {
    name: 'BannerEnhancedSearch',

    components: {
        BannerLocationSelect,
        BannerCommercialSelect,
    },

    props: {
        // the search params, emitted as 'input' on search btn click or reset
        initialParams: {
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        return {
            searchParams: { ...this.initialParams },
        };
    },

    methods: {
        getSearchParams() {
            return { ...this.searchParams };
        },

        onSearchBtn() {
            this.emitChangedParams();
        },

        onResetBtn() {
            this.searchParams = {};
            this.$emit('reset', {});
        },

        emitChangedParams() {
            this.$emit('search', { ...this.searchParams });
        },
    },
};
</script>
